<template>
  <v-tooltip top max-width="300">
    <template v-slot:activator="{ on, attrs }">
      <div class="icon-container" v-bind="attrs" v-on="on">
        <v-icon v-if="approved === true" size="24" :color="success">
          mdi-check-circle
        </v-icon>

        <v-icon v-else-if="approved === false" size="24" color="red">
          mdi-close-circle
        </v-icon>

        <v-icon v-else-if="unitLevelAndNull" size="24" :color="nullIconColour">
          mdi-circle
        </v-icon>
      </div>
    </template>
    <span>{{ tooltipMessage }}</span>
  </v-tooltip>
</template>

<script>
import colours from '../../../ow-colors';

export default {
  props: {
    approved: {
      required: true,
    },
    tooltipMessage: {
      type: String,
      default: () => null,
    },
    unitLevel: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      nullIconColour: colours.lightOnyx,
      success: colours.successGreen,
      catManGreen: colours.catManGreen,
    };
  },

  computed: {
    disableTooltip() {
      return this.tooltipMessage === null;
    },

    unitLevelAndNull() {
      return this.approved === null && this.unitLevel;
    },
  },
};
</script>

<style lang="scss" scoped>
.icon-container {
  display: flex;
  align-items: center;
  cursor: default;
}
</style>
